import React from 'react';

import './input.less';

const InputBlock = (props) => {
  let groupClass = `from-group inputBlock ${props.className ? props.className : ''}`;
  if (props.hasError) {
    groupClass = groupClass + ' error-message';
  }
  return (
    <div className={groupClass}>
      {props.label ? <label>{props.label}</label> : null}
      <div className="inputWrapper">
        <input
          className="calc-input"
          placeholder={props.placeholder}
          value={props.value ?? undefined}
          type={props.type ?? 'text'}
          onChange={props.onChange}
          {...props}
          onKeyDown={(e) => {
            if (e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 40) {
              props.type === 'number' && e.preventDefault();
            }
            if (e.keyCode === 13) {
              props.loginKeyDown && props.loginKeyDown();
            }
          }}
        />
      </div>
      <span style={{ color: 'red' }}>{props.hasError ? props.hasError : ''}</span>
    </div>
  );
};
export default InputBlock;
